export const getPageInfo = (path: string) => {
    switch (path) {
      case "/dashboard":
        return {
          title: "Dashboard",
          breadcrumb: ["Dashboard"],
        };
      case "/dashboard/general-data":
        return {
          title: "Datos",
          breadcrumb: ["Dashboard", "Datos"],
        };
      case "/dashboard/general-services":
        return {
          title: "Servicios",
          breadcrumb: ["Dashboard", "Servicios"],
        };
      case "/dashboard/schedule":
        return {
          title: "Horarios",
          breadcrumb: ["Dashboard", "Horarios"],
        };
      case "/dashboard/policy-data":
        return {
          title: "Políticas",
          breadcrumb: ["Dashboard", "Políticas"],
        };
      case "/dashboard/multimedia":
        return {
          title: "Multimedia",
          breadcrumb: ["Dashboard", "Multimedia"],
        };
      case "/dashboard/menu-categories":
        return {
          title: "Categorías",
          breadcrumb: ["Dashboard", "Inventario", "Categorías"],
        };
      case "/dashboard/products":
        return {
          title: "Productos",
          breadcrumb: ["Dashboard", "Inventario", "Productos"],
        };
      case "/dashboard/faqs":
        return {
          title: "FAQs",
          breadcrumb: ["Dashboard", "FAQs"],
        };
      case "/dashboard/payment-data":
        return {
          title: "Pagos",
          breadcrumb: ["Dashboard", "Pagos"],
        };
      case "/dashboard/plans-data":
        return {
          title: "Planes",
          breadcrumb: ["Dashboard", "Planes"],
        };
      case "/dashboard/packages-data":
        return {
          title: "Paquetes",
          breadcrumb: ["Dashboard", "Paquetes"],
        };
      case "/dashboard/normal-chat":
        return {
          title: "Chat Interno",
          breadcrumb: ["Dashboard", "Chats", "Chat Interno"],
        };
      case "/dashboard/whatsapp-chat":
        return {
          title: "Gestionar WhatsApp",
          breadcrumb: ["Dashboard", "Chats", "Gestionar WhatsApp"],
        };
      case "/dashboard/chat-data":
        return {
          title: "Historial de Chats",
          breadcrumb: ["Dashboard", "Historial de Chats"],
        };
      case "/dashboard/analytics":
        return {
          title: "Analítica",
          breadcrumb: ["Dashboard", "Analítica"],
        };
      case "/dashboard/user-profile":
        return {
          title: "Perfil de usuario",
          breadcrumb: ["Dashboard", "Perfil de usuario"],
        };
      case "/dashboard/whatsapp-integration":
        return {
          title: "Integración de WhatsApp",
          breadcrumb: ["Dashboard", "Integración de WhatsApp"],
        };
      case "/dashboard/agents-data":
        return {
          title: "Agentes Personalizados",
          breadcrumb: ["Dashboard", "Agentes Personalizados"],
        };
      case "/dashboard/agents-company-data":
        return {
          title: "Datos de Agentes",
          breadcrumb: ["Dashboard", "Datos de Agentes"],
        };
      default:
        return {
          title: "Dashboard",
          breadcrumb: ["Dashboard"],
        };
    }
  };
  